export enum ControlReason {
  INTERMEDIATE_CONTROL = 'INTERMEDIATE_CONTROL',
  ACCEPTANCE_CONTROL = 'ACCEPTANCE_CONTROL',
  DESIRED_CONTROL = 'DESIRED_CONTROL',
  PERIODIC_CONTROL = 'PERIODIC_CONTROL',
  FOLLOW_UP_CONTROL = 'FOLLOW_UP_CONTROL',
}
